import React from 'react'
import { connect } from 'react-redux'
import { OfferCard } from './OfferCard'
import OtherStoreOffers from './OtherStoreOffers'
import { PurchasedAction } from './purchased-action'
import { openReservePurchasedGiftModal } from '../../../modals/actions'

interface ExternalProductOfferProps {
  isMobile: boolean
  offers: Array<any>
  regItem: any
  registry: any
  trackedCreateReservation: any
  openReservePurchasedGiftModal: any
}

const ExternalProductOffer = ({
  isMobile,
  offers,
  regItem,
  registry,
  trackedCreateReservation,
  openReservePurchasedGiftModal,
}: ExternalProductOfferProps) => {
  const handleOpenModal = () => {
    openReservePurchasedGiftModal(regItem, registry, trackedCreateReservation)
  }

  return (
    <OfferCard isMobile={isMobile}>
      <OtherStoreOffers offers={offers} regItem={regItem} />
      <PurchasedAction openReservePurchasedGiftModal={handleOpenModal} />
    </OfferCard>
  )
}

export default connect(null, {
  openReservePurchasedGiftModal,
})(ExternalProductOffer)
